export default "__VITE_ASSET__B8fQm0LV__"